import { CircleChangeSponsorshipRequest } from '@calm/evexia-web-sdk';
import { useSponsorshipMutation } from '@rhg/hooks/use-sponsorship-mutation';

export function useUpgradeSponsorship() {
    const { mutate, mutateAsync, ...otherProps } =
        useSponsorshipMutation<CircleChangeSponsorshipRequest>(
            (api, { partnerId, circle, request }) =>
                api.v1UpgradeSponsorship({
                    partnerId,
                    circleAuthorizationToken: circle.authorizationJWT,
                    recipientId: circle.recipient.id,
                    circleChangeSponsorshipRequest: request,
                })
        );
    return {
        upgradeSponsorship: mutate,
        upgradeSponsorshipAsync: mutateAsync,
        ...otherProps,
    };
}
